import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import appAction from '@app/redux/app/actions';
import {message} from "antd";

const Errors = ()=>{
    const appErrors = useSelector((state) => state.App.errors);
    const dispatch = useDispatch();

    const onClose = () => {
        dispatch(appAction.cleanErrors());
    };

    const MessageComponent = (props) => {
        setTimeout(() => {
            onClose();
        }, 4000)

        return <>
            {
                props.errors && props.errors.map((err, index) => {
                    return <div>{err.msg}</div>;
                })
            }
        </>
    } 

    React.useEffect(()=>{
        for (let index = 0; index < appErrors.length; index++) {
            const err = appErrors[index];
            if(!err.msg) return;
            message.error(err.msg);
        }
    }, [appErrors]);

    return <>
        {/* {
            (appErrors && appErrors.length > 0 ) && <Alert message={<MessageComponent errors={appErrors}/>} type="error" closable afterClose={onClose}/>
        } */}
    </>;
}

// const CleanErrors = ()=>{
//     const dispatch = useDispatch();
//     dispatch(appAction.cleanErrors());
// }

export default Errors;